/* eslint-disable indent */
export const whiteLabel = () => {
  switch (window.location.hostname) {
    case "safe-owner.you-home.us":
      return {
        colors: {
          primary: "#3d4144",
          secondary: "#e198b6",
        },
        logoFileName: "safe-owner-logo",
        loginBackground: "random-background.jpg",
      };
    default:
      return {
        colors: {
          primary: "#053358",
          secondary: "#46ADC8",
        },
        logoFileName: "you-logo",
        loginBackground: "login-background.jpg",
      };
    // For demo purposes
    // return {
    //   colors: {
    //     primary: "#3d4144",
    //     secondary: "#e198b6",
    //   },
    //   logoFileName: "safe-owner-logo",
    //   loginBackground: "random-background.jpg"
    // };
  }
};
